import { useEffect } from "react";
import { connect } from "react-redux";
import { useRouter } from "next/router";
import { createStructuredSelector } from "reselect";

import { selectIsUserFetched } from "store/user/account/selectors";

const UserDetail = ({ isUserFetched }) => {
    const router = useRouter();
    useEffect(() => {
        if (isUserFetched) {
            router.push("/partner/overview");
        }
    }, [isUserFetched]);

    return null;
};

const mapStateToProps = createStructuredSelector({
    isUserFetched: selectIsUserFetched,
});

export default connect(mapStateToProps)(UserDetail);
